__turbopack_context__.v({
  "sliderRange": "uYrucW_sliderRange",
  "sliderRoot": "uYrucW_sliderRoot",
  "sliderThumb": "uYrucW_sliderThumb",
  "sliderTrack": "uYrucW_sliderTrack",
  "sliderValue": "uYrucW_sliderValue",
});
